module.exports = __webpack_public_path__ + "phabricator.0c74a0.svg";